export class BundleItem {
    Id?: number;
    ProductId?: number;
    EntryType?: string;
    PackageType?: string;
}
